import { ReactNode } from "react";

import { useTranslation } from "react-i18next";

import { ROUTES } from "@/shared";

import { colors } from "@dotnet/telematics-design-system";

import { SCHEDULES_LIMITS } from "../../../../../../Pages/Vehicles/types";
import BannerMessage, {
  BANNER_MESSAGE_STATUSES
} from "../../../../../BannerMessage/BannerMessage";
import Separator from "../../../../../Separator/Separator";
import { DETAILS_TITLES, DetailsDto } from "../../../../types";
import AccordionDetailsCard from "../AccordionDetailsCard/AccordionDetailsCard";

interface NoCardsProps {
  route: ROUTES;
  detailsData: DetailsDto;
  quickAction?: ReactNode;
  status: BANNER_MESSAGE_STATUSES;
  messageText: string;
  detailsTitle?: DETAILS_TITLES;
  maxCount?: number;
  currCount?: number;
  testId?: string;
}

const NoCards = ({
  route,
  detailsData,
  quickAction,
  status,
  messageText,
  detailsTitle,
  maxCount,
  currCount,
  testId
}: NoCardsProps) => {
  const { t } = useTranslation();

  return (
    <AccordionDetailsCard
      route={route}
      cardTitle={t(`Details##${detailsTitle || DETAILS_TITLES.Schedules}`)}
      maxCount={maxCount || SCHEDULES_LIMITS.MaxScheduleCount}
      currentCount={currCount || detailsData.schedulesCount}
      quickTitleAction={quickAction}
    >
      <Separator color={colors.gray200} />
      <BannerMessage
        data-testid={testId ?? "no-cards-component-banner"}
        status={status}
        title={t(`Details##${messageText}`)}
        externalCustomStyle={{ margin: "16px" }}
      />
    </AccordionDetailsCard>
  );
};

export default NoCards;
